/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ResponseTestDto } from '../models/response-test-dto';
import { testsControllerCreate } from '../fn/tests/tests-controller-create';
import { TestsControllerCreate$Params } from '../fn/tests/tests-controller-create';
import { testsControllerDelete } from '../fn/tests/tests-controller-delete';
import { TestsControllerDelete$Params } from '../fn/tests/tests-controller-delete';
import { testsControllerFilter } from '../fn/tests/tests-controller-filter';
import { TestsControllerFilter$Params } from '../fn/tests/tests-controller-filter';
import { testsControllerFindOne } from '../fn/tests/tests-controller-find-one';
import { TestsControllerFindOne$Params } from '../fn/tests/tests-controller-find-one';
import { testsControllerUpdate } from '../fn/tests/tests-controller-update';
import { TestsControllerUpdate$Params } from '../fn/tests/tests-controller-update';

@Injectable({ providedIn: 'root' })
export class TestsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `testsControllerCreate()` */
  static readonly TestsControllerCreatePath = '/thalea-pathways/tests';

  /**
   * Create a test.
   *
   * Creates a new test record.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `testsControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  testsControllerCreate$Response(params: TestsControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseTestDto>> {
    return testsControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a test.
   *
   * Creates a new test record.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `testsControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  testsControllerCreate(params: TestsControllerCreate$Params, context?: HttpContext): Observable<ResponseTestDto> {
    return this.testsControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseTestDto>): ResponseTestDto => r.body)
    );
  }

  /** Path part for operation `testsControllerFindOne()` */
  static readonly TestsControllerFindOnePath = '/thalea-pathways/tests/{tenant}/{id}';

  /**
   * Get test by ID.
   *
   * Retrieves a test record by tenant and id.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `testsControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  testsControllerFindOne$Response(params: TestsControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseTestDto>> {
    return testsControllerFindOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Get test by ID.
   *
   * Retrieves a test record by tenant and id.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `testsControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  testsControllerFindOne(params: TestsControllerFindOne$Params, context?: HttpContext): Observable<ResponseTestDto> {
    return this.testsControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseTestDto>): ResponseTestDto => r.body)
    );
  }

  /** Path part for operation `testsControllerUpdate()` */
  static readonly TestsControllerUpdatePath = '/thalea-pathways/tests/{tenant}/{id}';

  /**
   * Update a test.
   *
   * Updates an existing test record.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `testsControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  testsControllerUpdate$Response(params: TestsControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseTestDto>> {
    return testsControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a test.
   *
   * Updates an existing test record.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `testsControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  testsControllerUpdate(params: TestsControllerUpdate$Params, context?: HttpContext): Observable<ResponseTestDto> {
    return this.testsControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseTestDto>): ResponseTestDto => r.body)
    );
  }

  /** Path part for operation `testsControllerDelete()` */
  static readonly TestsControllerDeletePath = '/thalea-pathways/tests/{tenant}/{id}';

  /**
   * Delete a test.
   *
   * Deletes a test record.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `testsControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  testsControllerDelete$Response(params: TestsControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return testsControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a test.
   *
   * Deletes a test record.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `testsControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  testsControllerDelete(params: TestsControllerDelete$Params, context?: HttpContext): Observable<void> {
    return this.testsControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `testsControllerFilter()` */
  static readonly TestsControllerFilterPath = '/thalea-pathways/tests/filter';

  /**
   * Filter tests.
   *
   * Filters tests based on input parameters.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `testsControllerFilter()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  testsControllerFilter$Response(params: TestsControllerFilter$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponseTestDto>>> {
    return testsControllerFilter(this.http, this.rootUrl, params, context);
  }

  /**
   * Filter tests.
   *
   * Filters tests based on input parameters.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `testsControllerFilter$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  testsControllerFilter(params: TestsControllerFilter$Params, context?: HttpContext): Observable<Array<ResponseTestDto>> {
    return this.testsControllerFilter$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ResponseTestDto>>): Array<ResponseTestDto> => r.body)
    );
  }

}
